import { useQuery } from '@tanstack/react-query';
import { getUpsellPurchaseResult } from '@/api/upsellPurchase/getUpsellPurchaseResult';

const POLL_INTERVAL_MS = 2000;

export const usePollUpsellPurchaseResult = (
  transactionId: string,
  enabled: boolean,
  trackingInfo?: string,
  externalTransactionToken?: string,
) => {
  const { isLoading, data } = useQuery({
    queryKey: ['poll-upsell-purchase-result', transactionId, trackingInfo, externalTransactionToken],
    queryFn: () => getUpsellPurchaseResult(transactionId, trackingInfo, externalTransactionToken),
    enabled,
    refetchInterval: (data) => {
      if (!data?.inProgress) {
        return false;
      }
      return POLL_INTERVAL_MS;
    },
  });

  const isGranted = data?.productGranted || data?.alreadyEntitled || false;

  return {
    isGranted,
    isLoading,
  };
};
